module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-Demi.2708c5a2.ttf";